var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomScale = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.704 9.41a.703.703 0 0 0-.391-.336l-5.204-1.848a2.026 2.026 0 0 0-.616-1.53c-.886-.864-2.367-.795-3.157.19L8.14 4.04h-.001a.716.716 0 0 0-.868.336l-3.293 6.38h1.575l2.35-4.554 2.378 4.553h1.578l-2.523-4.83 3.553 1.261a2.061 2.061 0 0 0 1.408 1.91V22.42c0 .378.315.686.703.686a.695.695 0 0 0 .703-.686V9.096c.343-.118.65-.32.892-.593l4.497 1.597-2.96 5.737h1.574l2.37-4.592 2.371 4.592h1.575l-3.318-6.426zm-7.205-1.77a.718.718 0 0 1-.998 0 .677.677 0 0 1 0-.973.718.718 0 0 1 .998 0 .676.676 0 0 1 0 .973z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.828 21.78h-1.656c-1.998 0-3.623 1.585-3.623 3.534 0 .379.315.686.703.686h7.496a.695.695 0 0 0 .703-.686c0-1.949-1.625-3.535-3.623-3.535z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.297 17.209h-8.44a.695.695 0 0 0-.703.686c0 2.648 2.208 4.803 4.923 4.803S27 20.543 27 17.895a.695.695 0 0 0-.703-.686zM12.145 12.128H3.703a.695.695 0 0 0-.703.686c0 2.65 2.209 4.804 4.924 4.804 2.715 0 4.924-2.155 4.924-4.804a.695.695 0 0 0-.703-.686z",
    fill: "#F2AE18"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomScale);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-scale.9898e977007a7f79f9f5c49281105769.svg";